import { makeDefaultRequestMetadataExtensionsResolver } from "./request-metadata/default-resolver.js";
import { makeLGController } from "./lg-controller.js";
export const makeRuntimeLGController = (config, options) => makeLGController({
    ...options,
    resolveRequestMetadataExtensions: options?.resolveRequestMetadataExtensions ??
        makeDefaultRequestMetadataExtensionsResolver(config),
});
